export function SceneBlurSlider({ value = 0, onChange }) {
  const normalizedValue = Math.max(0, Math.min(100, Number(value) || 0));
  const updateFromPointer = (event) => {
    const track = event.currentTarget.parentElement;
    const rect = track.getBoundingClientRect();
    const position = Math.max(0, Math.min(1, (event.clientY - rect.top) / rect.height));
    onChange?.(Math.round((1 - position) * 100));
  };

  const handleMetricPointerDown = (event) => {
    event.preventDefault();
    event.currentTarget.setPointerCapture(event.pointerId);
    updateFromPointer(event);
  };

  const handleMetricPointerMove = (event) => {
    if (event.currentTarget.hasPointerCapture(event.pointerId)) {
      updateFromPointer(event);
    }
  };

  return (
    <div
      className="scene-blur-control"
      aria-label="Scene focus control"
      onPointerDown={(event) => event.stopPropagation()}
      onPointerMove={(event) => event.stopPropagation()}
      onTouchStart={(event) => event.stopPropagation()}
      onTouchMove={(event) => event.stopPropagation()}
    >
      <span className="scene-blur-control__label scene-blur-control__label--clear">
        How
        <br />
        Humans Sense
        <br />
        the World
      </span>
      <div className="scene-blur-control__track">
        <input
          className="scene-blur-control__range"
          type="range"
          min="0"
          max="100"
          step="1"
          value={normalizedValue}
          aria-label="Scene blur amount"
          aria-valuetext={`${normalizedValue}% blur`}
          onChange={(event) => onChange?.(Number(event.target.value))}
          style={{ "--scene-blur-progress": `${normalizedValue}%` }}
        />
        <output
          className="scene-blur-control__value"
          style={{ "--scene-blur-thumb-position": `${100 - normalizedValue}%` }}
          onPointerDown={handleMetricPointerDown}
          onPointerMove={handleMetricPointerMove}
          onPointerUp={(event) => event.currentTarget.releasePointerCapture(event.pointerId)}
          onPointerCancel={(event) => event.currentTarget.releasePointerCapture(event.pointerId)}
        >
          <strong>{normalizedValue}%</strong>
          <span>
            Spatial
            <br />
            Intelligence
          </span>
        </output>
      </div>
      <span className="scene-blur-control__label scene-blur-control__label--blur">
        How
        <br />
        AI Senses
        <br />
        the World
      </span>
    </div>
  );
}
